// v10/src/utils/roles.js
// Definición centralizada de permisos por rol

export const ROLES = {
  SUPERADMIN: 'superadmin',
  ADMIN:      'admin',
  INSTRUCTOR: 'instructor',
  PILOT:      'pilot',
};

// Qué puede hacer cada rol
export const PERMISSIONS = {
  // Gestión de usuarios (solo admin)
  manageUsers:       ['admin'],
  // Gestión de aeronaves y checklists
  manageAircraft:    ['admin', 'instructor'],
  editChecklist:     ['admin', 'instructor'],
  // Historial: admin ve todos, instructor ve sus pilotos, piloto solo el suyo
  viewAllHistory:    ['admin'],
  viewTeamHistory:   ['admin', 'instructor'],
  viewOwnHistory:    ['admin', 'instructor', 'pilot'],
  // Sistema (notificaciones, config global)
  systemSettings:    ['admin'],
  // Chequeo de aeronaves
  doChecklist:       ['admin', 'instructor', 'pilot'],
  // Panel de admin (acceso al panel en sí)
  accessAdminPanel:  ['admin', 'instructor'],
  accessSuperPanel:  ['superadmin'],
};

/**
 * Verifica si un rol tiene un permiso dado
 * @param {string} role - 'admin' | 'instructor' | 'pilot'
 * @param {string} permission - clave de PERMISSIONS
 * @returns {boolean}
 */
export const can = (role, permission) => {
  if (!role || !permission) return false;
  return PERMISSIONS[permission]?.includes(role) ?? false;
};

/**
 * Hook / helper para verificar múltiples permisos de un usuario
 * @param {object} user - objeto con campo `role`
 * @returns {{ can: (permission: string) => boolean, role: string }}
 */
export const usePermissions = (user) => {
  const role = user?.role || ROLES.PILOT;
  return {
    role,
    can: (permission) => can(role, permission),
    isSuperAdmin: role === ROLES.SUPERADMIN,
    isAdmin:      role === ROLES.ADMIN,
    isInstructor: role === ROLES.INSTRUCTOR,
    isPilot:      role === ROLES.PILOT,
    canAccessPanel:  can(role, 'accessAdminPanel'),
    canAccessSuperPanel: role === ROLES.SUPERADMIN,
  };
};
